export default {"src":"/_next/static/media/cover2.02b91e58.svg","height":560,"width":1440,"blurWidth":0,"blurHeight":0};